import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import Summary from './components/Summary'
import LegalFormalities from './components/LegalFormalities'
import LegalFormalitiesTabs from './components/LegalFormalities/Tabs'
import ContactHeader from './components/ContactHeader'
import Staff from './components/Staff'
import ContactContextProvider from 'contexts/contactContext'
import LegalFormalitiesContextProvider from 'contexts/legalFormalitiesContext'

const Customer = () => {
  const urlParams = useParams()
  const location = useLocation()
  const contactId = urlParams.contactId
  const [activeTabKey, setActiveTabKey] = useState<string>(
    urlParams.tabkey || 'resume'
  )

  useEffect(() => {
    setActiveTabKey(urlParams.tabKey || 'resume')
  }, [location])

  if (!contactId) return <></>

  return (
    <ContactContextProvider contactId={parseInt(contactId)}>
      <LegalFormalitiesContextProvider contactId={parseInt(contactId)}>
        <div>
          <ContactHeader activeTab={activeTabKey} setActive={setActiveTabKey}>
            {activeTabKey == 'legal_formalities' && <LegalFormalitiesTabs />}
          </ContactHeader>

          {activeTabKey == 'resume' && (
            <Summary setActiveTabKey={setActiveTabKey} />
          )}

          {activeTabKey == 'legal_formalities' && <LegalFormalities />}
          {activeTabKey == 'staff' && <Staff />}
        </div>
      </LegalFormalitiesContextProvider>
    </ContactContextProvider>
  )
}

export default Customer
